import { SessionUser } from './auth-session.model';
import { rolesIncludeSuperadmin } from './superadmin-access';
import { TEAM_ADMIN_PERMISSIONS } from './nav-permissions.config';

export type PermissionCheckFn = (resource: string, action: string) => boolean;

export function canManageTeamFromPermissions(can: PermissionCheckFn): boolean {
  return TEAM_ADMIN_PERMISSIONS.some((req) => can(req.resource, req.action));
}

export function canManageTeamAccess(
  user: SessionUser | null | undefined,
  can?: PermissionCheckFn
): boolean {
  if (!user) {
    return false;
  }
  const roles = user.roles ?? [];
  if (rolesIncludeSuperadmin(roles)) {
    return true;
  }
  // Alineado con rolesCanManageTeamAccess: rol admin cuenta aunque exista `can`.
  if (roles.includes('admin') || roles.includes('owner')) {
    return true;
  }
  if (can) {
    return canManageTeamFromPermissions(can);
  }
  return false;
}

export function rolesCanManageTeamAccess(
  roles: string[] | null | undefined,
  can?: PermissionCheckFn
): boolean {
  if (rolesIncludeSuperadmin(roles)) {
    return true;
  }
  if (roles?.includes('admin')) {
    return true;
  }
  if (can && canManageTeamFromPermissions(can)) {
    return true;
  }
  return false;
}
